var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React from 'react';
import { spaceSxFromProps } from '@revdotcom/vaporwave-system';
import { getTextLinkSx, } from '@revdotcom/vaporwave-sx';
import { forwardCommonProps } from '../Helpers/CommonProps';
var getTargetAndRelProps = function (openInNewTab, target, rel) {
    if (openInNewTab) {
        if (target || rel) {
            console.warn('`openInNewTab` will override user-specified values for `target` or `rel` when true');
        }
        return { target: '_blank', rel: 'noopener noreferrer' };
    }
    return { target: target, rel: rel };
};
var VaporwaveLink = function (_a, ref) {
    var href = _a.href, _b = _a.openInNewTab, openInNewTab = _b === void 0 ? false : _b, target = _a.target, rel = _a.rel, _c = _a.download, download = _c === void 0 ? false : _c, onClick = _a.onClick, children = _a.children, _d = _a.color, color = _d === void 0 ? 'primary' : _d, _e = _a.sizeVariant, sizeVariant = _e === void 0 ? 'xxs' : _e, rest = __rest(_a, ["href", "openInNewTab", "target", "rel", "download", "onClick", "children", "color", "sizeVariant"]);
    var fallbackRef = React.useRef(null);
    var DomRef = ref !== null && ref !== void 0 ? ref : fallbackRef;
    var targetAndRelProps = getTargetAndRelProps(openInNewTab, target, rel);
    return (_jsx("a", __assign({ ref: DomRef, href: href, download: download, onClick: onClick }, targetAndRelProps, forwardCommonProps(rest), { sx: __assign(__assign({}, getTextLinkSx(color, sizeVariant)), spaceSxFromProps(rest)), children: children })));
};
/**
 * Renders a link to a specified URL.
 *
 * The vaporwave Link component can be styled using the styled-system margin props.
 */
export var Link = React.forwardRef(VaporwaveLink);
